import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
  resetSecureFieldFormControl,
  secureFieldInputBeforeInput,
  secureFieldTypeFocus,
} from '@blaze-shared/shared-feature';

import { type InlineEditorConfig } from '../base-editor/inline-editor.types';

@UntilDestroy()
@Component({
  selector: 'be-secure-text-editor',
  templateUrl: './secure-text-editor.component.html',
  styleUrls: ['./secure-text-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableSecureTextEditorComponent implements AfterViewInit {
  valueChange = output<string>();

  @Input() config?: InlineEditorConfig;

  @ViewChild('stringInput') stringInput!: ElementRef<HTMLInputElement>;

  formControl = new UntypedFormControl('');
  secureFieldType: 'text' | 'password' = 'password';
  secureFieldTypeFocusFn = (event: FocusEvent, stringInput: HTMLInputElement): void => {
    secureFieldTypeFocus(stringInput);
  };

  secureFieldTypeBlurFn = (event: FocusEvent, formControl: UntypedFormControl): void => {
    resetSecureFieldFormControl(formControl);
  };

  secureFieldInputBeforeInputFn = (event: InputEvent, formControl: UntypedFormControl): void => {
    secureFieldInputBeforeInput(event, formControl);
  };
  @Input() set value(val: string | number | undefined) {
    this.formControl.patchValue(val);
  }

  constructor() {
    this.formControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.emitValue(value);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.stringInput.nativeElement.select());
  }

  changeSecureTextType(type = this.secureFieldType): void {
    this.secureFieldType = type === 'text' ? 'password' : 'text';
  }

  private emitValue(value: string): void {
    this.valueChange.emit(value);
  }
}
